module.exports = __webpack_public_path__ + "img/USS.1b7b86d4.gif";